import { render } from "./FooterDualActions.vue?vue&type=template&id=4e2c7726&scoped=true"
import script from "./FooterDualActions.vue?vue&type=script&lang=js"
export * from "./FooterDualActions.vue?vue&type=script&lang=js"

import "./FooterDualActions.vue?vue&type=style&index=0&id=4e2c7726&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\eric.aparicio\\Documents\\REPOS\\ubiku.2023-master\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e2c7726"]])

export default __exports__